import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';
import {
  ActionButtonContainer,
  StyledAddIcon,
  StyledTrashIcon,
  StyledCopyIcon,
  StyledUpdateIcon,
  StyledClipboardIcon,
  StyledPasteIcon,
} from './styles';
import texts from './texts.json';

const ActionButtons = ({
  onAdd,
  onRemove,
  onDuplicate,
  onUpdate,
  onCopy,
  onPaste,
}) => (

  <ActionButtonContainer>
    {!!onAdd && (
      <Tooltip title={texts.add}>
        <IconButton onClick={onAdd}>
          <StyledAddIcon />
        </IconButton>
      </Tooltip>
    )}
    <Tooltip title={texts.update}>
      <IconButton onClick={onUpdate}>
        <StyledUpdateIcon />
      </IconButton>
    </Tooltip>
    <Tooltip title={texts.delete}>
      <IconButton onClick={onRemove}>
        <StyledTrashIcon />
      </IconButton>
    </Tooltip>
    <Tooltip title={texts.duplicate}>
      <IconButton onClick={onDuplicate}>
        <StyledCopyIcon />
      </IconButton>
    </Tooltip>
    {!!onCopy && (
      <Tooltip title={texts.copy}>
        <IconButton onClick={onCopy}>
          <StyledClipboardIcon />
        </IconButton>
      </Tooltip>
    )}
    {!!onPaste && (
      <Tooltip title={texts.paste}>
        <IconButton onClick={onPaste}>
          <StyledPasteIcon />
        </IconButton>
      </Tooltip>
    )}
  </ActionButtonContainer>
);

ActionButtons.propTypes = {
  onAdd: PropTypes.func,
  onRemove: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onCopy: PropTypes.func,
  onPaste: PropTypes.func,
};

ActionButtons.defaultProps = {
  onAdd: null,
  onCopy: null,
  onPaste: null,
};

export default ActionButtons;
